import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray, AbstractControl } from '@angular/forms';
import { Role } from '../../../models/role.model';
import { DtoModule, DtoPackage, DtoPackageModule, DtoPreviewItem, DtoSubCategory, SubCategoryPayload } from '../../../models/package-center.model';
import { PackageService } from '../../package-center/package/package.service';
import { ProdetailsModalComponent } from '../../data-management/prodetails-modal/prodetails-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { SharedService } from '../../../shared/services/shared.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { RoleMaster } from '../user-role/user-role.component';
@Component({
  selector: 'app-create-role',
  templateUrl: './create-role.component.html'
})
export class CreateRoleComponent implements OnInit {
  @Input() isEdit: boolean = false;
  @Input() assignedPackageId: number = 0;
  @Input() openedFromIndividualSchool: boolean = false;
  @Input() roleData: Role[] = [];
  @Input() requestToCreate: boolean = false;
  @Input() createRole: boolean = false;
  userRole: string[] = [];
  availableGroupedSubCategories: { [key: string]: DtoSubCategory[] } = {};
  groupedSubCategories: { [key: string]: DtoSubCategory[] } = {};
  rolesMaster = RoleMaster;

  modules: DtoModule[] = [];
  roleForm = new FormGroup({
    roleDetails: new FormArray([]),
  });
  package:DtoPackage = {} as DtoPackage;

  constructor(private packageService: PackageService, private dialog: MatDialog,
              private sharedService: SharedService, private toasterService: ToastrService
  ){}

  ngOnInit(): void {
    this.userRole = sessionStorage.getItem('user_role')?.split(',')!;
    this.getPackageByPackageId(this.assignedPackageId);
    this.sharedService.roleFormValidity.subscribe(roleForm => {
      if(roleForm.controls['roleDetails']){
        this.roleForm = roleForm;
      }
    });
    setTimeout(()=>{
      this.roleForm.statusChanges.subscribe(status => {
        this.sharedService.updateRoleFormValidity(this.roleForm);
      });
    }, 2000);

  }

  _createGroupedValues(subCategories: DtoSubCategory[]){
    return (subCategories??[]).reduce((result, sc) => 
            {
              const key = sc.moduleDisplayName!;
              result[key] = result[key] || [];
              result[key].push(sc);
              return result;
            },{} as {[key:string]: DtoSubCategory[]});
  }

  clearRoleForm(){
    this.roleForm.reset();
    let arrayLength = this.rolesArray.length;
    for (let i = 0; i< arrayLength; i++) {
      this.rolesArray.removeAt(i);
      if(this.rolesArray.length == 0) {
        this.addRoleDetail();
      }
    }
  }

  getPackageByPackageId(assignedPackageId: number) {
    this.packageService.getPackageByPackageId(assignedPackageId).subscribe((response: DtoPackage[] | any)=>{
      this.package = response[0];
      if(this.isEdit){
        if(this.rolesArray.length == 0) {
          this.addRoleDetail();
        }
        for(let i=0; i < this.roleForm.get('roleDetails')!.value.length; i++){
          let role: any = this.roleForm.get('roleDetails')!.value[i];
          
          (this.rolesArray.at(i) as FormGroup).controls['roleId'].setValue((this.roleData[i] && this.roleData[i].roleId) ? this.roleData[i].roleId : 0);
          (this.rolesArray.at(i) as FormGroup).controls['roleName'].setValue(role.roleName);
          
          let moduleData: DtoPackageModule[] = role.modules.map((x: DtoModule) => ({
            packageModuleId: this.assignedPackageId,
            packageId: this.assignedPackageId,

            moduleId: x.moduleId,
            moduleName: x.moduleName
          }))
          let moduleList = this.package.modules.filter((module: DtoPackageModule) => {
            return moduleData.some((packageModule: DtoPackageModule) => module.moduleId === packageModule.moduleId);
          });
          (this.rolesArray.at(i) as FormGroup).controls['modules']!.setValue(moduleList);
          let payload = role.modules.map((x: DtoModule) => ({
            moduleId: x.moduleId,
            moduleName: x.moduleName
          }))
          this.packageService.getSubCategoriesOfPackage(payload, this.assignedPackageId).subscribe((response: DtoSubCategory[] | any) => {
            (this.rolesArray.at(i) as FormGroup).controls['allSubCategories'].setValue(response);
            this.availableGroupedSubCategories = this._createGroupedValues(response);

            let subCategoryList = (this.rolesArray.at(i) as FormGroup).controls['allSubCategories'].value.filter((subCategory: DtoSubCategory) => {
              return role.subCategories.some((packagesubCategory: DtoSubCategory) => subCategory.subCategoryId === packagesubCategory.subCategoryId);
            });

            (this.rolesArray.at(i) as FormGroup).controls['subCategories'].setValue(subCategoryList);
            this.groupedSubCategories = this._createGroupedValues(subCategoryList);
          },(err: HttpErrorResponse)=>{
            if(err.error){
              this.toasterService.error(err.error, "Error");
            }
          })
        }
      }
      else if(this.roleForm.get('roleDetails')!.value.length){
        for(let i=0; i < this.roleForm.get('roleDetails')!.value.length; i++){
          let role: any = this.roleForm.get('roleDetails')!.value[i];

          let moduleData: DtoPackageModule[] = role.modules.map((x: DtoModule) => ({
            packageModuleId: this.assignedPackageId,
            packageId: this.assignedPackageId,

            moduleId: x.moduleId,
            moduleName: x.moduleName
          }))
          let moduleList = this.package.modules.filter((module: DtoPackageModule) => {
            return moduleData.some((packageModule: DtoPackageModule) => module.moduleId === packageModule.moduleId);
          });
          (this.rolesArray.at(i) as FormGroup).controls['modules']!.setValue(moduleList)
        }
      }
      else{
        this.addRoleDetail();
      }
    },(err: HttpErrorResponse)=>{
      if(err.error){
        this.toasterService.error(err.error, "Error");
      }
    });
  }

  removeModule(moduleToRemove: DtoModule, role: any){
    this.getFormGroup(role).controls['modules'].setValue(this.getFormGroup(role).controls['modules'].value.filter((x: DtoModule)=>x.moduleId != moduleToRemove.moduleId));
    this.onModuleChange({value: this.getFormGroup(role).controls['modules'].value}, role);
  }

  previewPopup(title: string, type: string, role: any){
    this.dialog.open(ProdetailsModalComponent,{
      width: '1000px',
      panelClass: 'modal-prodetails',
      data: {
        singleItemPreview: title ? true : false,
        packageDetails: {},
        itemToPreview: type == 'Module' ? this.getFormGroup(role).controls['modules'].value.map((x: DtoModule)=>({
          groupName: null,
          itemName: x.moduleName})) as DtoPreviewItem[]:
                                          this.getFormGroup(role).controls['subCategories'].value.map((x: DtoSubCategory)=>({
                                          groupName: x.moduleDisplayName, 
                                          itemName: x.subCategoryName})) as DtoPreviewItem[],
        title: title
      }
    })
  }
  
  addRoleDetail(roles: Role[] = []) {
    if (roles.length) {
      roles.forEach((data: Role) => {
        let newForm = this.getRoleForm();
        
        newForm.patchValue({
          roleId: data.roleId,
          roleName: data.roleName,
          modules: data.modules,
          subCategories: data.subCategories
        });
        let moduleData: DtoPackageModule[] = data.modules.map((x: DtoModule) => ({
          packageModuleId: this.assignedPackageId,
          packageId: this.assignedPackageId,
          moduleId: x.moduleId,
          moduleName: x.moduleName
        }));
        let moduleList = this.package.modules.filter((module: DtoPackageModule) => {
          return moduleData.some((packageModule: DtoPackageModule) => module.moduleId === packageModule.moduleId);
        });

        this.getFormGroup(newForm).controls['modules'].setValue(moduleList);
        
        let payload = data.modules.map((x: DtoModule) => ({
          moduleId: x.moduleId,
          moduleName: x.moduleName
        }));

        this.packageService.getSubCategoriesOfPackage(payload, this.assignedPackageId).subscribe((response: DtoSubCategory[] | any) => {
          this.getFormGroup(newForm).controls['allSubCategories'].setValue(response);
          this.availableGroupedSubCategories = this._createGroupedValues(response);

          let subCategoryList = this.getFormGroup(newForm).controls['allSubCategories'].value.filter((subCategory: DtoSubCategory) => {
            return data.subCategories.some((packagesubCategory: DtoSubCategory) => subCategory.subCategoryId === packagesubCategory.subCategoryId);
          });
          this.getFormGroup(newForm).controls['subCategories'].setValue(subCategoryList);
          this.groupedSubCategories = this._createGroupedValues(subCategoryList);

        },(err: HttpErrorResponse)=>{
          if(err.error){
            this.toasterService.error(err.error, "Error");
          }
        })

        this.rolesArray.insert(0, newForm);
      });
    } else {
      const form = this.getRoleForm();
      this.rolesArray.push(form);
    }
  }

  patchRoleDetail(data: Role[]) {
    this.roleForm.markAllAsTouched();
    this.rolesArray.clear();
    if (data.length) {
      this.addRoleDetail(data);
    }
  }

  get rolesArray(): FormArray {
    return this.roleForm.get('roleDetails') as FormArray;
  }

  getFormGroup(control: AbstractControl) {
    return control as FormGroup;
  }

  getRoleForm(): FormGroup {
    return new FormGroup({
      roleId: new FormControl(0),
      roleName: new FormControl('', [
        Validators.required,
        Validators.pattern('^.*[a-zA-Z]+.*$ ?'),
      ]),
      modules: new FormControl([], [
        Validators.required
      ]),
      subCategories: new FormControl([], [
        Validators.required
      ]),
      allSubCategories: new FormControl([], [
        Validators.required
      ])
    });
  }

  onDeleteRole(index: number) {
    this.rolesArray.removeAt(index);
  }

  onModuleChange(selectedModule: any, role: any){
    let payload = selectedModule.value;
    this.packageService.getSubCategoriesOfPackage(payload, this.assignedPackageId).subscribe((response: DtoSubCategory[] | any) => {
      this.getFormGroup(role).controls['allSubCategories'].setValue(response);
      this.availableGroupedSubCategories = this._createGroupedValues(response);

      let subCategoryList = this.getFormGroup(role).controls['allSubCategories'].value.filter((subCategory: DtoSubCategory) => {
        return this.getFormGroup(role).controls['subCategories'].value?.some((packagesubCategory: DtoSubCategory) => subCategory.subCategoryId === packagesubCategory.subCategoryId);
      });
      this.getFormGroup(role).controls['subCategories'].setValue(subCategoryList);
      this.groupedSubCategories = this._createGroupedValues(subCategoryList);

    },(err: HttpErrorResponse)=>{
      if(err.error){
        this.toasterService.error(err.error, "Error");
      }
    })
  }

  removeSubCategory(SubCategoryToRemove: DtoSubCategory, role: any){
    var subCategoryList = this.getFormGroup(role).controls['subCategories'].value.filter((x: DtoSubCategory)=>x.subCategoryId != SubCategoryToRemove.subCategoryId);

    this.getFormGroup(role).controls['subCategories'].setValue(subCategoryList);
    this.groupedSubCategories = this._createGroupedValues(subCategoryList);
  }

}
